module.exports = __webpack_public_path__ + "files/01aa59e34acc5aa4fe7d8064df01cf4c.png";